import { localeUrl } from '@marketplace/helpers/url.js'

/**
 * Check if user is logged in.
 *
 * @param {object} root0
 * @param {object} root0.app
 * @param {Function} root0.redirect
 * @param root0.route
 */
export default async function ({ app, redirect, route }) {
    const isLoggedIn = await app.$helpers.isLoggedIn

    if (!isLoggedIn) {
        redirect(
            `${localeUrl('/')}?returnUrl=${encodeURIComponent(
                route.fullPath
            )}#login`
        )
    }
}
